<template>
  <div class="modal__crop-image">
    <div class="modal__crop-image__header">
      <img src="@/assets/closeBlack.svg" @click.prevent="closeModal">
    </div>
    <div class="modal__crop-image__photo" v-show="imagePreview != ''">
      <vue-cropper
        ref="cropper" :src="image" alt="Crop image" :aspectRatio="1">
      </vue-cropper>
    </div>
    <button class="modal__crop-image__action" :class="{'disabled': loadingPictureProfile}" 
      :disabled="loadingPictureProfile" @click.prevent="uploadProfile">{{$t('modal.picture.action')}}</button>
  </div>
</template>
<script>
// import persistentData from '@/plugins/persistentData'
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import { mapState } from 'vuex';
import cropImage from "@/plugins/cropImages"
import storage from "@/plugins/azure-storage"

export default {
  components: {
    VueCropper
  },
  props: {
    closeModal: Function
  },
  data() {
    return {
      loadingPictureProfile: false,
      isApp: window["cordova"] != undefined
    } 
  },
  computed: {
    ...mapState({
      imagePreview: state => state.ProfileModule.imagePreview,
      profile: state => state.ProfileModule.profile
    }),
    image() {
      return URL.createObjectURL(this.imagePreview)
    }
  },
  methods: {
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), 
          n = bstr.length, 
          u8arr = new Uint8Array(n);
          
      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }
      
      const fileData = new File([u8arr], filename, {type:mime});
      return fileData;
    },
    async uploadProfile() {
      const self = this
      if (self.loadingPictureProfile) return
      self.loadingPictureProfile = true

      if (self.isApp) {
        self.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
          blob.name = "profile.jpg"
          self.updateFile(blob)
        }, "image/jpg")
      } else {
        const image = self.dataURLtoFile(self.$refs.cropper.getCroppedCanvas().toDataURL(), "profile.jpg")
        self.updateFile(image)
      } 

    },
    async updateFile(image) {
      const self = this
      const imageCropped = await cropImage.crop(image, 100, 100, 'profile.jpg', 'image/jpeg')
      
      storage.updateFile(imageCropped, process.env.VUE_APP_CDN_CONTAINERNAME).then(res => {
        self.$store.dispatch('updateImageProfile', res)
        self.$store.dispatch('profileUpdate', self.profile)
        self.loadingPictureProfile = false
        self.$store.dispatch('closeModal')
        self.$store.dispatch('addNotification', {
          value: self.$t('notifications.updateImageProfile'),
          status: "success",
          remove: true
        })
      })
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.modal__crop-image {
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 400px;
  background: $white;
  min-height: 208px;
  width: 100%;
  border-radius: $redondeadobig;
  position: relative;

  &__header {
    padding: $margin-base;
    align-self: flex-end;
    z-index: 3;
    cursor: pointer;
    position: sticky;
    top: 0;
  }

  &__photo {
    margin-bottom: $margin-kilo;

    img {
      object-fit: contain;
      width: 100%;
    }

    &__inflable__container {
      position: relative;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: $white;
      width: 100%;
      max-width: 280px;
      text-align: center;

      img {
        margin-bottom: $margin-kilo;
      }
    }
  }

  &__action {
    width: 100%;
    background: $lightblue;
    color: $white;
    padding: $margin-base;
    margin-bottom: 0;
    text-transform: uppercase;
    font-weight: 700;
    border-radius: 0 0 $redondeadobig $redondeadobig;
    z-index: 2;
    // border-top: 1px solid $white;
    // position: absolute;
    // bottom: -8px;
    position: sticky;
    bottom: 0;

    &.disabled {
      opacity: .5;
    }
  }
}
</style>